import { useMemo } from 'react'
import { useScreenSizeUp } from 'hooks/useScreenSize'
import { hasTouchCapability } from 'lib/web/deviceUtils'
import useHasMounted from 'hooks/useHasMounted'

/**
 * Hook to determine if the user is on a desktop device without touch capability.
 * Useful for showing hover-only UI elements that shouldn't appear on touch devices.
 *
 * Returns false during SSR and initial client render to prevent hydration mismatches.
 */
function useDesktopWithoutTouch(): boolean {
  const hasMounted = useHasMounted()
  const hasTouch = useMemo(() => hasTouchCapability(), [])
  const isDesktop = useScreenSizeUp('desktop')

  if (!hasMounted) {
    return false
  }

  return isDesktop && !hasTouch
}

export default useDesktopWithoutTouch
